import {BaseManager} from "../../../infrastructure/managers/base-manager";
import {KinesisProvider} from "./kinesis-provider";
import {DomUtils} from "../../../infrastructure/utils/dom-utils";
import {LoggerUtils} from "../../../infrastructure/utils/logger/logger-utils";
import {SiteConfig} from "../../../core/bootstrap/models/site-config";
import {DeviceStore} from "../../../core/app/device.store";
import {singleton} from "../../../infrastructure/decorators/singleton";

@singleton
export class KinesisManager extends BaseManager {
  provider: KinesisProvider;
  senderInterval = 0;
  senderIntervalTimeout = 10 * 1000;
  quotaLimit = 10;

  static injectables = [...BaseManager.injectables, KinesisProvider];

  constructor(
    domUtils: DomUtils,
    loggerUtils: LoggerUtils,
    siteConfig: SiteConfig,
    deviceStore: DeviceStore,
    provider: KinesisProvider
  ) {
    super(domUtils, loggerUtils, siteConfig, deviceStore);

    this.provider = provider;

    this.createSenderInterval();

    this.provider.onEventCreated = () => this.onEventCreated();
  }

  get isQuotaExceeded() {
    return this.provider.batchEventsCount >= this.quotaLimit;
  }

  createSenderInterval() {
    this.senderInterval = setInterval(() => this.execute(), this.senderIntervalTimeout);
  }

  execute() {
    this.provider.send();
  }

  onEventCreated() {
    if (this.isQuotaExceeded && this.provider.initialized) {
      this.provider.send();

      clearInterval(this.senderInterval);

      this.createSenderInterval();
    }
  }
}

